import type { MarketingRouter } from "replo-publisher/src/trpc/routers/marketing";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: marketingRouter,
  client: marketingClient,
  utils: marketingUtils,
  options: marketingOptions,
} = createTrpcRouterConfig<MarketingRouter>({
  path: "marketing",
  queryClient: getNamespacedQueryClient("marketing"),
});

export { marketingClient, marketingRouter, marketingUtils, marketingOptions };
